import { render, staticRenderFns } from "./VoidTriggers.vue?vue&type=template&id=3772881f"
import script from "./VoidTriggers.vue?vue&type=script&lang=ts"
export * from "./VoidTriggers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-intelligent-match/mfe-intelligent-match/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3772881f')) {
      api.createRecord('3772881f', component.options)
    } else {
      api.reload('3772881f', component.options)
    }
    module.hot.accept("./VoidTriggers.vue?vue&type=template&id=3772881f", function () {
      api.rerender('3772881f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VoidTriggers.vue"
export default component.exports